import { Navigate } from "@tanstack/react-router";
import { useVendorId } from "@/features/vendors/detail/use-vendor-id";

/** Vendor hub Orders tab → purchase list filtered to this vendor. */
export function VendorOrdersPage() {
  const vendorId = useVendorId();
  return <Navigate to="/purchase" search={{ vendor: vendorId }} />;
}
